<template>
    <div class="hstack p-2 rounded-4 gap-3">
        <a :href="isAndroid ? 'https://play.google.com/store/apps/details?id=io.dateit.app.android' : 'https://apps.apple.com/us/app/dateit/id1610780514'" class="center btn btn-primary">
            <font-awesome-icon icon="fa-solid fa-bell" class="me-2" />
            <span>Get notifications and important updates</span>
        </a>
    </div>
</template>

<script lang="ts" setup>
import { mobileUtil } from "@/util/MobileUtil";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faBell);

const { isAndroid } = mobileUtil();
</script>

<style scoped>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    color: #ffffff !important;
    text-decoration: none;
}

.center:hover {
    color: #ffffff !important;
    text-decoration: none;
}

.gift-icon {
    width: auto;
    height: 30px;
}

.getApp {
    color: #fff !important;
}
.amzn-box {
    background-color: #fff;
}
.app-badge {
    height: 30px;
    width: auto;
}
.amz-link {
    font-size: 10pt;
    text-decoration: inherit;
    color: #ffffff !important;
    font-weight: bold;
    background-color: #f0f0f0;
    background: linear-gradient(180deg, rgba(34, 97, 255, 1) 0%, rgba(101, 33, 239, 1) 100%);
}

@media (min-width: 768px) {
    .amz-link {
        font-size: 15px;
    }
    .app-badge {
        height: 50px;
    }

    .gift-icon {
        height: 50px;
    }
}
</style>
